import {Heading} from '@primer/react'

import styles from './RepositoryProjects.module.css'

export function ProjectsActions() {
  return (
    <div className={styles.buttonGrp}>
      <Heading as="h1" className={styles.heading}>
        Projects
      </Heading>
    </div>
  )
}
